const INDIA_TIMEZONE = "Asia/Kolkata";

export type VedicDateLocale = "en" | "hi";

/**
 * Format an engine-owned YYYY-MM-DD without allowing the browser timezone to
 * move the civil date across a boundary.
 */
export function formatVedicEngineDate(iso: string, locale: VedicDateLocale = "en"): string {
  const parsed = new Date(`${iso}T00:00:00+05:30`);
  if (Number.isNaN(parsed.getTime())) return iso;
  return new Intl.DateTimeFormat(locale === "hi" ? "hi-IN" : "en-IN", {
    timeZone: INDIA_TIMEZONE,
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(parsed);
}

/** Return today's civil date in India as YYYY-MM-DD. */
export function currentIndiaDate(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: INDIA_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}
